const isObject = (value) => value != null && typeof value === 'object' && !Array.isArray(value);

export const mergeAppResources = (currentResources, resourceUpdates) => {
  const baseResources = isObject(currentResources) ? currentResources : {};
  if (!isObject(resourceUpdates)) {
    return baseResources;
  }

  const nextResources = { ...baseResources };

  Object.entries(resourceUpdates).forEach(([resourceKey, resourceValue]) => {
    if (resourceValue == null) {
      return;
    }

    if (isObject(resourceValue) && isObject(baseResources[resourceKey])) {
      nextResources[resourceKey] = {
        ...baseResources[resourceKey],
        ...resourceValue,
      };
      return;
    }

    nextResources[resourceKey] = resourceValue;
  });

  return nextResources;
};

export const mergeProfileWithUpdates = (previousProfile, updates) => {
  if (!previousProfile || !isObject(updates)) {
    return previousProfile;
  }

  const nextProfile = {
    ...previousProfile,
    ...updates,
  };

  if (isObject(updates.app_resources)) {
    nextProfile.app_resources = mergeAppResources(previousProfile.app_resources, updates.app_resources);
  }

  return nextProfile;
};
